import React from "react"
import PageTemplate from "../components/pageTemplate"
import { Container, Row, Col } from "reactstrap"
import { FaCode, FaRegClipboard, FaRegAddressBook, FaHome, FaHandsHelping,FaProjectDiagram } from "react-icons/fa"
import { 
  RiSettings6Line,
  RiDeleteBack2Fill,
  RiDatabase2Line
 } from "react-icons/ri"
import { 
  BiTransfer, BiCalendarEdit, BiCalendarCheck
 } from "react-icons/bi"
import { 
  HiOutlineDocumentText
 } from "react-icons/hi"
import { 
  FiTrash2
 } from "react-icons/fi"
import Box from "../components/box"
import SEO from "../components/seo"
import Button from "../components/btn"
import Form from "../components/form"
import Hr from "../components/hr"

// import "bootstrap/dist/css/bootstrap.min.css"

let Portfolio = ({ title, description, example }) => (
  <Col xs={12} md={12} className="mb-4">
    {/* <Link to="/"> */}
        {/* <Icon size={40} style={{display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color:"white", backgroundColor: '#b23a48'}}/> */}
        
        <p className="mt-3" style={{fontWeight:'bold'}}>{title}</p>
        <p className="mt-3">{description}</p>
        
        <p className="mt-3">{example}</p>
    {/* </Link> */}
  </Col>
)

let ProductInfo = ({ Icon = FaHome, title, content }) => (
  <div className="d-flex mb-4">
    {/* <div><FaCode size={20} style={{color: '#f77f00'}} /></div> */}
    <div>
      <Icon size={40} style={{display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color:"white", backgroundColor: '#A00429'}}/>
    </div>
    <div className="ml-3">
      <p className="m-0" style="font-weight: bold;">{title}</p>
      <p className="m-0 text-muted">{content}</p>
    </div>
  </div>
)

let IconProduct = ({ Icon = FaHome }) => (
  <Icon size={40} style={{display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color:"white", backgroundColor: '#A00429'}}/>
  )

let Product = () => (
  <PageTemplate title="Product">
    <SEO title="Product" />
    <Container className="py-5">
    <h2 className="text-center my-5 mt-10" style={{fontWeight:'900'}}>Humantastic</h2>
      <Col xs={12} md={12} className="mb-4">
      <Row>
        <Box>
          <Row>
            <Col xs={12} md={12} className="mb-4">
              <Button target="_blank" rel="noopener norefferer" style={{background:'maroon'}} to="https://thehumantastic.com">Humantastic Official Website</Button>
              <p className="mt-3" style={{fontWeight:'bold'}}>Human Resource Management System</p>
              <p className="mt-3">Closely monitor employee records and
              personnel actions, HR compliance,
              benefits administration, absence
              management, reporting (standard and
              custom), and data import/export actions. Submit an absence application from
              anywhere, see the remaining number of
              holiday days available, track requests and
              access all personal documents (contract,
              certificates, emergency contacts etc.)
              from anywhere.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={FaRegClipboard} title="PAYROLL" content="Automation helps speed up payroll processing and makes it easier to generate reports."></ProductInfo>
            </Col>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={HiOutlineDocumentText} title="CLAIM" content="Create, track and manage employees claims."></ProductInfo>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={BiCalendarEdit} title="LEAVE" content="Manage leave request and track leave through calendar."></ProductInfo>
            </Col>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={BiCalendarCheck} title="ATTENDANCE" content="Maintains detailed and summary attendance history, and tracks reports of all types."></ProductInfo>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} className="mb-4">
              <ProductInfo Icon={RiSettings6Line} title="MANAGEMENT" content="Centralized data storage. Customization of your company's management involving the main modules."></ProductInfo>
            </Col>
          </Row>
        </Box>
      </Row>
      </Col>
        <div className="py-5">
            <Container>
              <Row className="d-flex justify-content-center">
                <Col md={8}>
                  <Box style={{ textAlign: "left" }}>
                    <h3 className="text-center">Contact Us</h3>
                    <Hr />
                    <Form />
                  </Box>
                </Col>
              </Row>
            </Container>
          </div>
    </Container>
  </PageTemplate>
)

export default Product
